import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

const HeroSection: React.FC = () => {
  const [scrollY, setScrollY] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      setScrollY(window.scrollY);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <section className="relative overflow-hidden min-h-[85vh] flex items-center">
      {/* Animated background with elegant colors */}
      <div className="absolute inset-0 bg-gradient-to-b from-slate-900 via-blue-900 to-slate-900 z-0">
        {/* Subtle dot pattern */}
        <div className="absolute inset-0 opacity-30">
          <div className="absolute w-full h-full bg-[url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGNpcmNsZSBjeD0iMTAiIGN5PSIxMCIgcj0iMSIgZmlsbD0iI2ZmZiIgZmlsbC1vcGFjaXR5PSIwLjMiLz48L3N2Zz4=')]"></div>
        </div>
        
        {/* Subtle ambient orbs */}
        <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-blue-600 rounded-full mix-blend-soft-light filter blur-[80px] opacity-40 animate-blob"></div>
        <div className="absolute bottom-1/4 right-1/4 w-96 h-96 bg-indigo-600 rounded-full mix-blend-soft-light filter blur-[100px] opacity-40 animate-blob animation-delay-2000"></div>
      </div>
      
      {/* Content layer - with parallax effect */}
      <div className="container relative z-10 mx-auto px-6 py-20 text-center">
        <h1 
          className="text-5xl md:text-6xl lg:text-7xl font-extrabold mb-8 text-white"
          style={{ transform: `translateY(${scrollY * 0.1}px)` }}
        >
          Skip the Learning Curve, <br/>
          <span className="bg-clip-text text-transparent bg-gradient-to-r from-blue-300 to-cyan-200">Start Making Money</span>
        </h1>
        
        <p 
          className="mb-12 text-xl md:text-2xl text-blue-100 max-w-3xl mx-auto leading-relaxed"
          style={{ transform: `translateY(${scrollY * 0.05}px)` }}
        >
          Our AI handles the complex business planning so you can focus on what matters — building your customer base and revenue. Start your 7-day free trial today.
        </p>
        
        {/* CTA button */}
        <div 
          className="relative inline-block"
          style={{ transform: `translateY(${scrollY * 0.02}px)` }}
        >
          <Link to="/signup" className="relative px-8 py-4 bg-white text-blue-900 font-semibold text-lg rounded-lg shadow-lg hover:shadow-xl transform transition-all duration-300 hover:scale-105 hover:-translate-y-1 inline-block">
            Start Your Free 7 Day Trial Now
            <div className="absolute inset-0 rounded-lg opacity-30 blur-sm bg-blue-300 -z-10 group-hover:opacity-40"></div>
          </Link>
        </div>
        
        {/* Subtle floating elements */}
        <div className="absolute -left-4 top-1/4 text-white opacity-10 text-6xl transform rotate-12 animate-float">✨</div>
        <div className="absolute right-8 top-1/3 text-white opacity-10 text-7xl transform -rotate-12 animate-float-delayed">🚀</div>
      </div>
    </section>
  );
};

export default HeroSection;
